import membersToggleHtml from './membersToggle.html';
export default {
  templateUrl: membersToggleHtml,
  bindings: {
    count: '<',
    isOpened: '<',
    toggle: '&',
  },
  controllerAs: 'ctrl',
};
